import { Row, Col } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import Spinner from "react-bootstrap/Spinner";

//Services
import Api from "../../services/api";

//Components
import FilterBox from "../../Components/filterBox/filterBox";
import TableList from "../../Components/tableList/TableList";
import MessageTable from "../../Components/messageTable/MessageTable";
import InputReport from "../../Components/inputReport/inputReport";
import Button from "../../Components/commonButton/commonButton";

//Styles
import "./generalReports.css";
import styles from "../General/details.module.css";
import "./generalReports.css";
import "../../global.css";

const reportFactories = () => {
  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [filters, setFilters] = useState([]);
  const [control, setControl] = useState([1]);
  const [loading, setLoading] = useState(true);

  //Esse use effect faz a requisição na api e puxa os dados pela primeira vez. Coloquei o nome de componentDidMount() pois ele executa somente na primeira renderização.

  useEffect(() => {
    function firstLoad() {
      let array = [];
      Api.get("/factorys")
        .then((response) => {
          response.data.forEach((element) => {
            array.push({
              Planta: element.description,
              Código: element.code,
            });
          });
          if (array.length > 0) {
            //Se a quantidade de dados for maior que zero ele salva os dados nos seguintes states: data e dataFilter. Depois ele desabilita a tela de loading.
            setData([...array]);
            setDataFilter([...array]);
            setLoading(false);
          }
        })
        .catch((err) => {
          alert(err);
        });
    }

    firstLoad();
  }, []);

  //Essa função serve para capturarmos e armazenarmos em um state "filters" o que está sendo digitado nos filtros.

  const saveText = (element) => {
    let { value, name } = element;
    setFilters({ [`${name}`]: value });
  };

  const button = () => {
    setLoading(true);
    setControl([...[1]]);
  };
  // Essa função é executada quando clicamos em um botão.

  useEffect(() => {
    //Captura o nome dos filtros que estão sendo usados.
    let aux = Object.keys(filters);
    //Se existir uma filtragem ele usa a função .filter para filtrar o state data e armazenar em uma variável arr.
    if (aux.length > 0 && filters[aux] != null && filters[aux] != "") {
      let arr = data.filter((element) => element[aux] == filters[aux]);

      //Depois ele armazena a varíavel arr no state dataFilter;
      setDataFilter([...arr]);

      console.log("State 'dataFilter'");
      console.log(dataFilter);
    } else {
      setDataFilter([...data]);
    }

    setLoading(false);
  }, [control]);

  return (
    <div className="filters boxReport">
      <FilterBox title="Filtros">
        <Row type="input" className="w-100">
          <Col lg={4} sm={6} type="input" className="p-1 mb-1">
            <InputReport
              name="Planta"
              title="Planta"
              max="30"
              parentCallback={saveText}
              validationType="varchar"
              focus={true}
            />
          </Col>
          <Col lg={4} sm={6} type="input" className="p-1 mb-1">
            {" "}
            <InputReport
              name="Código"
              title="Código"
              parentCallback={saveText}
              validationType="int"
            />
          </Col>
        </Row>
        <Row type="input" className="w-100">
          <Col className="p-0" xs={12} sm={6} md={3} lg={2}>
            <div className="submitButton">
              <Button
                title="Gerar"
                className="btn-fixed"
                icon="faGear"
                parentCallback={button}
              />
            </div>
          </Col>
        </Row>
      </FilterBox>
      <div className="TableReport" id="tabela">
        {loading ? (
          <div style={{ marginTop: "20vh" }} className={styles.loader}>
            <Spinner variant="success" animation="border" />
            <strong>Carregando...</strong>
          </div>
        ) : (
          <>
            {dataFilter.length > 0 ? (
              <TableList data={dataFilter}></TableList>
            ) : (
              <MessageTable message={"Sem dados para processar."} />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default reportFactories;
